import React, { useEffect, useState, useContext } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { AuthContext } from '../App';
import api from '../api';
import { ruhsatBelgesiOlustur } from '../components/RuhsatBelgesiPDF';

const DURUM_ETIKET = {
  BASVURU:'Beklemede', ONAYLANDI:'Tamamlandı', IPTAL:'İptal Ruhsat',
  INTIKAL_RUHSAT:'İntikal Ruhsat', SON_KONTROL:'Son Kontrol Bekliyor',
  ON_KONTROL:'Beklemede', ASKIDA:'Beklemede'
};

function KontrolTutanagi({ ruhsatId, tip, sorular, ekstraAlanlar }) {
  const { kullanici } = useContext(AuthContext);
  const [veri, setVeri] = useState(null);
  const [form, setForm] = useState({});
  const [kayitModu, setKayitModu] = useState(false);
  const [kaydediliyor, setKaydediliyor] = useState(false);
  const endpoint = tip === 'on' ? 'onkontrol' : tip === 'son' ? 'sonkontrol' : tip === 'beyan' ? 'beyan' : tip === 'tespit' ? 'tespit' : 'zabitakontrol';
  const yazabilir = (tip === 'zabita' || tip === 'tespit')
    ? ['admin','mudur','zabita'].includes(kullanici?.rol)
    : ['admin','mudur','personel'].includes(kullanici?.rol);

  useEffect(() => {
    api.get(`/ruhsat/${ruhsatId}/${endpoint}`).then(r => { setVeri(r.data); if (r.data) setForm(r.data); });
  }, [ruhsatId, endpoint]);

  const kaydet = async () => {
    setKaydediliyor(true);
    try {
      const tarihKey = tip === 'beyan' ? 'beyan_tarihi' : 'kontrol_tarihi';
      const r = await api.post(`/ruhsat/${ruhsatId}/${endpoint}`, { ...form, [tarihKey]: form[tarihKey] || new Date().toISOString().split('T')[0] });
      setVeri(r.data); setKayitModu(false); alert('Kayıt tamamlandı!');
    } catch (err) { alert(err.response?.data?.hata || 'Hata oluştu'); }
    finally { setKaydediliyor(false); }
  };

  return (
    <div>
      {!kayitModu && veri && (
        <div>
          <div style={{display:'flex', gap:'16px', marginBottom:'12px', flexWrap:'wrap', background:'#f8f9fa', padding:'10px', borderRadius:'6px'}}>
            {tip === 'beyan'
              ? <span style={{fontSize:'13px', color:'#555'}}>Beyan Tarihi: <strong>{veri.beyan_tarihi ? new Date(veri.beyan_tarihi).toLocaleDateString('tr-TR') : '-'}</strong></span>
              : <span style={{fontSize:'13px', color:'#555'}}>Kontrol Tarihi: <strong>{veri.kontrol_tarihi ? new Date(veri.kontrol_tarihi).toLocaleDateString('tr-TR') : '-'}</strong></span>
            }
            {tip !== 'beyan' && <span style={{fontSize:'13px', color:'#555'}}>Sonuç: <strong style={{color: veri.onay_durumu==='UYGUN'?'green':veri.onay_durumu==='UYGUN_DEGIL'?'red':'orange'}}>{veri.onay_durumu}</strong></span>}
            {(veri.kontrol_eden_adi||veri.beyan_eden_adi) && <span style={{fontSize:'13px', color:'#555'}}>{tip==='beyan'?'Beyan Eden':'Kontrol Eden'}: <strong>{veri.beyan_eden_adi||veri.kontrol_eden_adi}</strong></span>}
          </div>
          {sorular.map((s, i) => {
            const key = `s${i+1}`;
            const isExtra = ekstraAlanlar && s.extra;
            return (
              <div key={key} className="kontrol-madde">
                <span style={{fontSize:'12px', color:'#555', minWidth:'20px'}}>{i+1}.</span>
                <label style={{flex:1, fontSize:'12px'}}>{s.label || s}</label>
                <span style={{fontSize:'13px', fontWeight:'600', color: veri[key]===true?'#1b5e20':veri[key]===false?'#b71c1c':'#999'}}>
                  {veri[key]===true ? '✅ Evet' : veri[key]===false ? '❌ Hayır' : '—'}
                </span>
              </div>
            );
          })}
          {tip==='on' && veri.s4_mesafe && <p style={{fontSize:'12px', color:'#555', background:'#fff3e0', padding:'6px 10px', borderRadius:'4px', margin:'8px 0'}}>S4 - Mesafe: <strong>{veri.s4_mesafe} metre</strong></p>}
          {veri.genel_aciklama && <p style={{marginTop:'10px', fontSize:'12px', color:'#555', background:'#f5f5f5', padding:'8px', borderRadius:'4px'}}><strong>Genel Açıklama:</strong> {veri.genel_aciklama}</p>}
          {(tip==='zabita'||tip==='tespit') && veri.tespit_notlari && <p style={{marginTop:'6px', fontSize:'12px', color:'#555', background:'#fff8e1', padding:'8px', borderRadius:'4px'}}><strong>Tespit Notları:</strong> {veri.tespit_notlari}</p>}
          {yazabilir && <button className="btn btn-outline btn-sm" style={{marginTop:'10px'}} onClick={() => setKayitModu(true)}>Yeni Tutanak Gir</button>}
        </div>
      )}
      {!kayitModu && !veri && (
        <div>
          <p style={{color:'#999', marginBottom:'10px', fontSize:'13px'}}>Henüz tutanak girilmemiş.</p>
          {yazabilir && <button className="btn btn-primary btn-sm" onClick={() => { setKayitModu(true); setForm({}); }}>➕ Tutanak Gir</button>}
        </div>
      )}
      {kayitModu && (
        <div>
          <div className="form-group" style={{marginBottom:'12px'}}>
            <label>Kontrol Tarihi</label>
            <input type="date" value={form.kontrol_tarihi||''} onChange={e => setForm({...form, kontrol_tarihi: e.target.value})} />
          </div>
          {sorular.map((s, i) => {
            const key = `s${i+1}`;
            return (
              <div key={key} className="kontrol-madde">
                <span style={{fontSize:'12px', color:'#555', minWidth:'20px'}}>{i+1}.</span>
                <label style={{flex:1, fontSize:'12px'}}>{s.label || s}</label>
                <div className="evet-hayir">
                  <label><input type="radio" name={key} checked={form[key]===true} onChange={() => setForm({...form, [key]: true})} /> Evet</label>
                  <label><input type="radio" name={key} checked={form[key]===false} onChange={() => setForm({...form, [key]: false})} /> Hayır</label>
                </div>
              </div>
            );
          })}
          {tip==='on' && (
            <div className="form-group" style={{marginTop:'10px'}}>
              <label>S4 - Okul/Mabede Mesafe (metre)</label>
              <input type="number" value={form.s4_mesafe||''} onChange={e => setForm({...form, s4_mesafe: e.target.value})} placeholder="Metre cinsinden mesafe" />
            </div>
          )}
          <div className="form-group" style={{marginTop:'12px'}}>
            <label>Genel Açıklama</label>
            <textarea value={form.genel_aciklama||''} onChange={e => setForm({...form, genel_aciklama: e.target.value})} rows={3} />
          </div>
          {(tip==='zabita'||tip==='tespit') && (
            <div className="form-group">
              <label>Tespit Notları</label>
              <textarea value={form.tespit_notlari||''} onChange={e => setForm({...form, tespit_notlari: e.target.value})} rows={3} placeholder="Tespitler..." />
            </div>
          )}
          {tip !== 'beyan' && (
          <div className="form-group">
            <label>Kontrol Sonucu</label>
            <select value={form.onay_durumu||'BEKLEMEDE'} onChange={e => setForm({...form, onay_durumu: e.target.value})}>
              <option value="BEKLEMEDE">Beklemede</option>
              <option value="UYGUN">Uygun</option>
              <option value="UYGUN_DEGIL">Uygun Değil</option>
            </select>
          </div>
          )}
          <div style={{display:'flex', gap:'8px', marginTop:'12px'}}>
            <button className="btn btn-success btn-sm" onClick={kaydet} disabled={kaydediliyor}>{kaydediliyor ? 'Kaydediliyor...' : '💾 Kaydet'}</button>
            <button className="btn btn-secondary btn-sm" onClick={() => setKayitModu(false)}>İptal</button>
          </div>
        </div>
      )}
    </div>
  );
}

function RuhsatEkler({ ruhsatId }) {
  const { kullanici } = useContext(AuthContext);
  const [ekler, setEkler] = useState([]);
  const [modalAcik, setModalAcik] = useState(false);
  const [form, setForm] = useState({ ek_turu:'MUZIK', ek_no:'', baslangic_tarihi:'', bitis_tarihi:'', aciklama:'' });
  const yazabilir = ['admin','mudur'].includes(kullanici?.rol);

  useEffect(() => { yukle(); }, [ruhsatId]);
  const yukle = () => api.get(`/ruhsat/${ruhsatId}/ekler`).then(r => setEkler(r.data));

  const kaydet = async (e) => {
    e.preventDefault();
    try {
      await api.post(`/ruhsat/${ruhsatId}/ekler`, form);
      yukle(); setModalAcik(false); setForm({ ek_turu:'MUZIK', ek_no:'', baslangic_tarihi:'', bitis_tarihi:'', aciklama:'' });
    } catch (err) { alert(err.response?.data?.hata || 'Hata'); }
  };

  const onayla = async (ekId) => {
    if (!window.confirm('Bu eki onaylamak istediğinize emin misiniz?')) return;
    await api.patch(`/ruhsat/${ruhsatId}/ekler/${ekId}/onayla`);
    yukle();
  };

  const sil = async (ekId) => {
    if (!window.confirm('Bu eki silmek istediğinize emin misiniz?')) return;
    await api.delete(`/ruhsat/${ruhsatId}/ekler/${ekId}`);
    yukle();
  };

  const EK_TURU = { MUDUR:'Müdür Eki', IZIN:'İzin Eki', MUZIK:'Müzik İzni' };

  return (
    <div>
      {yazabilir && (
        <div style={{marginBottom:'12px'}}>
          <button className="btn btn-primary btn-sm" onClick={() => setModalAcik(true)}>➕ Yeni Ek Ekle</button>
        </div>
      )}
      {ekler.length === 0 ? (
        <p style={{color:'#999', fontSize:'13px'}}>Henüz ruhsat eki bulunmuyor.</p>
      ) : (
        <table>
          <thead><tr><th>Ek Türü</th><th>Ek No</th><th>Başlangıç</th><th>Bitiş</th><th>Açıklama</th><th>Onay</th><th>İşlem</th></tr></thead>
          <tbody>
            {ekler.map(e => (
              <tr key={e.id}>
                <td><span style={{fontSize:'11px', padding:'2px 8px', borderRadius:'10px', background:'#e8eaf6', color:'#3949ab', fontWeight:'600'}}>{EK_TURU[e.ek_turu]||e.ek_turu}</span></td>
                <td style={{fontFamily:'monospace'}}>{e.ek_no||'—'}</td>
                <td>{e.baslangic_tarihi ? new Date(e.baslangic_tarihi).toLocaleDateString('tr-TR') : '—'}</td>
                <td>{e.bitis_tarihi ? new Date(e.bitis_tarihi).toLocaleDateString('tr-TR') : '—'}</td>
                <td style={{fontSize:'12px', color:'#666'}}>{e.aciklama||'—'}</td>
                <td>{e.onayli ? <span style={{color:'green', fontSize:'12px'}}>✅ Onaylı</span> : <span style={{color:'#f57c00', fontSize:'12px'}}>⏳ Bekliyor</span>}</td>
                <td style={{display:'flex', gap:'4px'}}>
                  {yazabilir && !e.onayli && <button className="btn btn-success btn-xs" onClick={() => onayla(e.id)}>Onayla</button>}
                  {yazabilir && <button className="btn btn-outline btn-xs" style={{color:'red'}} onClick={() => sil(e.id)}>Sil</button>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      {modalAcik && (
        <div className="modal-overlay" onClick={e => e.target===e.currentTarget && setModalAcik(false)}>
          <div className="modal" style={{maxWidth:'450px'}}>
            <div className="modal-header">
              <span className="modal-title">Yeni Ruhsat Eki</span>
              <button className="modal-close" onClick={() => setModalAcik(false)}>×</button>
            </div>
            <form onSubmit={kaydet}>
              <div className="form-group" style={{marginBottom:'12px'}}>
                <label>Ek Türü *</label>
                <select value={form.ek_turu} onChange={e => setForm({...form, ek_turu: e.target.value})} required>
                  <option value="MUDUR">Müdür Eki</option>
                  <option value="IZIN">İzin Eki</option>
                  <option value="MUZIK">Müzik İzni</option>
                </select>
              </div>
              <div className="form-group" style={{marginBottom:'12px'}}><label>Ek No</label><input value={form.ek_no} onChange={e => setForm({...form, ek_no: e.target.value})} /></div>
              <div className="form-grid">
                <div className="form-group"><label>Başlangıç Tarihi</label><input type="date" value={form.baslangic_tarihi} onChange={e => setForm({...form, baslangic_tarihi: e.target.value})} /></div>
                <div className="form-group"><label>Bitiş Tarihi</label><input type="date" value={form.bitis_tarihi} onChange={e => setForm({...form, bitis_tarihi: e.target.value})} /></div>
              </div>
              <div className="form-group"><label>Açıklama</label><textarea value={form.aciklama} onChange={e => setForm({...form, aciklama: e.target.value})} rows={2} /></div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setModalAcik(false)}>İptal</button>
                <button type="submit" className="btn btn-primary">Kaydet</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

function HarcTab({ ruhsatId }) {
  const { kullanici } = useContext(AuthContext);
  const [veri, setVeri] = useState([]);
  const [modalAcik, setModalAcik] = useState(false);
  const [odemeModal, setOdemeModal] = useState(null);
  const [form, setForm] = useState({ harc_turu:'RUHSAT_HARCI', aciklama:'', tutar:'', tahakkuk_tarihi:new Date().toISOString().split('T')[0] });
  const [odemeForm, setOdemeForm] = useState({ odeme_tarihi:new Date().toISOString().split('T')[0], makbuz_no:'', odeme_yontemi:'NAKIT' });
  const yazabilir = ['admin','mudur','personel'].includes(kullanici?.rol);
  const mudurAdmin = ['admin','mudur'].includes(kullanici?.rol);
  const fmt = d => d ? new Date(d).toLocaleDateString('tr-TR') : '—';
  const para = v => v ? Number(v).toLocaleString('tr-TR',{minimumFractionDigits:2})+' ₺' : '—';

  useEffect(() => { yukle(); }, [ruhsatId]); // eslint-disable-line
  const yukle = () => api.get(`/harc/ruhsat/${ruhsatId}`).then(r=>setVeri(r.data||[]));

  const kaydet = async (e) => {
    e.preventDefault();
    try { await api.post('/harc', {...form, ruhsat_id:ruhsatId}); yukle(); setModalAcik(false); setForm({harc_turu:'RUHSAT_HARCI',aciklama:'',tutar:'',tahakkuk_tarihi:new Date().toISOString().split('T')[0]}); }
    catch(err) { alert(err.response?.data?.hata||'Hata'); }
  };
  const odeKaydet = async (e) => {
    e.preventDefault();
    try { await api.patch(`/harc/${odemeModal.id}/ode`, odemeForm); yukle(); setOdemeModal(null); }
    catch(err) { alert(err.response?.data?.hata||'Hata'); }
  };
  const sil = async (id) => {
    if (!window.confirm('Silinecek. Emin misiniz?')) return;
    try { await api.delete(`/harc/${id}`); yukle(); } catch(err){ alert(err.response?.data?.hata||'Hata'); }
  };

  const toplam = veri.reduce((a,v)=>a+Number(v.tutar||0),0);
  const odenen = veri.filter(v=>v.odendi).reduce((a,v)=>a+Number(v.tutar||0),0);

  return (
    <div>
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'12px'}}>
        <div style={{display:'flex',gap:'16px'}}>
          <span style={{fontSize:'13px'}}>Toplam: <strong style={{color:'#1565c0'}}>{para(toplam)}</strong></span>
          <span style={{fontSize:'13px'}}>Tahsil: <strong style={{color:'#1b5e20'}}>{para(odenen)}</strong></span>
          <span style={{fontSize:'13px'}}>Bekleyen: <strong style={{color:'#c62828'}}>{para(toplam-odenen)}</strong></span>
        </div>
        {yazabilir && <button className="btn btn-primary btn-sm" onClick={()=>setModalAcik(true)}>➕ Harç Tahakkuk</button>}
      </div>
      {veri.length===0 ? <p style={{color:'#999',fontSize:'13px'}}>Harç kaydı bulunmuyor.</p> : (
        <table>
          <thead><tr><th>Tür</th><th>Açıklama</th><th>Tahakkuk</th><th>Tutar</th><th>Durum</th><th>Makbuz</th><th>İşlem</th></tr></thead>
          <tbody>
            {veri.map(h=>(
              <tr key={h.id}>
                <td style={{fontSize:'11px',fontWeight:'600'}}>{h.harc_turu?.replace(/_/g,' ')}</td>
                <td style={{fontSize:'12px'}}>{h.aciklama||'—'}</td>
                <td style={{fontSize:'12px'}}>{fmt(h.tahakkuk_tarihi)}</td>
                <td style={{fontWeight:'700',color:'#1565c0'}}>{para(h.tutar)}</td>
                <td>{h.odendi?<span style={{color:'#1b5e20',fontSize:'11px',fontWeight:'700'}}>✅ Ödendi</span>:<span style={{color:'#c62828',fontSize:'11px',fontWeight:'700'}}>⏳ Bekliyor</span>}</td>
                <td style={{fontSize:'11px',fontFamily:'monospace'}}>{h.makbuz_no||'—'}</td>
                <td style={{display:'flex',gap:'4px'}}>
                  {yazabilir&&!h.odendi&&<button className="btn btn-primary btn-xs" onClick={()=>{setOdemeModal(h);setOdemeForm({odeme_tarihi:new Date().toISOString().split('T')[0],makbuz_no:'',odeme_yontemi:'NAKIT'});}}>Öde</button>}
                  {mudurAdmin&&!h.odendi&&<button className="btn btn-outline btn-xs" style={{color:'red'}} onClick={()=>sil(h.id)}>Sil</button>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      {modalAcik&&(
        <div className="modal-overlay" onClick={e=>e.target===e.currentTarget&&setModalAcik(false)}>
          <div className="modal" style={{maxWidth:'420px'}}>
            <div className="modal-header"><span className="modal-title">Harç Tahakkuk Ettir</span><button className="modal-close" onClick={()=>setModalAcik(false)}>×</button></div>
            <form onSubmit={kaydet}>
              <div className="form-group"><label>Harç Türü *</label>
                <select value={form.harc_turu} onChange={e=>setForm({...form,harc_turu:e.target.value})} required>
                  {['RUHSAT_HARCI','YENILEME_HARCI','DEVIR_HARCI','CEZA_HARCI','BASVURU_UCRETI','DIGER'].map(k=><option key={k} value={k}>{k.replace(/_/g,' ')}</option>)}
                </select>
              </div>
              <div className="form-group"><label>Tutar (₺) *</label><input type="number" step="0.01" min="0" value={form.tutar} onChange={e=>setForm({...form,tutar:e.target.value})} required /></div>
              <div className="form-group"><label>Tahakkuk Tarihi</label><input type="date" value={form.tahakkuk_tarihi} onChange={e=>setForm({...form,tahakkuk_tarihi:e.target.value})} /></div>
              <div className="form-group"><label>Açıklama</label><textarea value={form.aciklama} onChange={e=>setForm({...form,aciklama:e.target.value})} rows={2}/></div>
              <div className="modal-footer"><button type="button" className="btn btn-secondary" onClick={()=>setModalAcik(false)}>İptal</button><button type="submit" className="btn btn-primary">Tahakkuk Ettir</button></div>
            </form>
          </div>
        </div>
      )}
      {odemeModal&&(
        <div className="modal-overlay" onClick={e=>e.target===e.currentTarget&&setOdemeModal(null)}>
          <div className="modal" style={{maxWidth:'380px'}}>
            <div className="modal-header"><span className="modal-title">Ödeme Kaydet — {para(odemeModal.tutar)}</span><button className="modal-close" onClick={()=>setOdemeModal(null)}>×</button></div>
            <form onSubmit={odeKaydet}>
              <div className="form-group"><label>Ödeme Tarihi</label><input type="date" value={odemeForm.odeme_tarihi} onChange={e=>setOdemeForm({...odemeForm,odeme_tarihi:e.target.value})} required /></div>
              <div className="form-group"><label>Makbuz No</label><input value={odemeForm.makbuz_no} onChange={e=>setOdemeForm({...odemeForm,makbuz_no:e.target.value})} /></div>
              <div className="form-group"><label>Ödeme Yöntemi</label>
                <select value={odemeForm.odeme_yontemi} onChange={e=>setOdemeForm({...odemeForm,odeme_yontemi:e.target.value})}>
                  {['NAKIT','KREDI_KARTI','HAVALE','EFT','DIGER'].map(k=><option key={k} value={k}>{k.replace(/_/g,' ')}</option>)}
                </select>
              </div>
              <div className="modal-footer"><button type="button" className="btn btn-secondary" onClick={()=>setOdemeModal(null)}>İptal</button><button type="submit" className="btn btn-primary">✅ Ödendi</button></div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

function SikayetTab({ ruhsatId }) {
  const { kullanici } = useContext(AuthContext);
  const [veri, setVeri] = useState([]);
  const [modalAcik, setModalAcik] = useState(false);
  const [form, setForm] = useState({ sikayet_kaynagi:'VATANDAS', sikayet_konusu:'', sikayet_aciklama:'', anonim:false, basvuru_sahibi:'', sikayet_tarihi:new Date().toISOString().split('T')[0] });
  const yazabilir = ['admin','mudur','personel'].includes(kullanici?.rol);
  const SONUC_RENK = { BEKLEMEDE:'#e65100', INCELENIYOR:'#1565c0', SONUCLANDI:'#1b5e20', KAPATILDI:'#555', YETKISIZ:'#888' };
  const fmt = d => d ? new Date(d).toLocaleDateString('tr-TR') : '—';

  useEffect(() => { api.get(`/sikayet/ruhsat/${ruhsatId}`).then(r=>setVeri(r.data||[])); }, [ruhsatId]);
  const yukle = () => api.get(`/sikayet/ruhsat/${ruhsatId}`).then(r=>setVeri(r.data||[]));

  const kaydet = async (e) => {
    e.preventDefault();
    try { await api.post('/sikayet', {...form, ruhsat_id:ruhsatId}); yukle(); setModalAcik(false); }
    catch(err){ alert(err.response?.data?.hata||'Hata'); }
  };

  return (
    <div>
      <div style={{display:'flex',justifyContent:'space-between',marginBottom:'12px'}}>
        <span style={{fontSize:'13px',color:'#666'}}>{veri.length} şikayet / ihbar kaydı</span>
        {yazabilir&&<button className="btn btn-primary btn-sm" onClick={()=>setModalAcik(true)}>➕ Şikayet Ekle</button>}
      </div>
      {veri.length===0?<p style={{color:'#999',fontSize:'13px'}}>Bu işyerine ait şikayet kaydı yok.</p>:(
        <table>
          <thead><tr><th>Şikayet No</th><th>Tarih</th><th>Konu</th><th>Başvuran</th><th>Sonuç</th></tr></thead>
          <tbody>
            {veri.map(s=>(
              <tr key={s.id}>
                <td style={{fontFamily:'monospace',fontSize:'12px',color:'#1a237e'}}>{s.sikayet_no}</td>
                <td style={{fontSize:'12px'}}>{fmt(s.sikayet_tarihi)}</td>
                <td style={{fontSize:'11px'}}>{s.sikayet_konusu?.replace(/_/g,' ')}</td>
                <td style={{fontSize:'12px'}}>{s.anonim?'Anonim':s.basvuru_sahibi||'—'}</td>
                <td><span style={{fontSize:'11px',fontWeight:'700',color:SONUC_RENK[s.sonuc]||'#555'}}>{s.sonuc?.replace(/_/g,' ')}</span></td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      {modalAcik&&(
        <div className="modal-overlay" onClick={e=>e.target===e.currentTarget&&setModalAcik(false)}>
          <div className="modal" style={{maxWidth:'480px'}}>
            <div className="modal-header"><span className="modal-title">Yeni Şikayet / İhbar Kaydı</span><button className="modal-close" onClick={()=>setModalAcik(false)}>×</button></div>
            <form onSubmit={kaydet}>
              <div className="form-grid">
                <div className="form-group"><label>Kaynak</label>
                  <select value={form.sikayet_kaynagi} onChange={e=>setForm({...form,sikayet_kaynagi:e.target.value})}>
                    {['VATANDAS','DIGER_KURUM','BASIN','RESEN','IHBAR_HATTI'].map(k=><option key={k} value={k}>{k.replace(/_/g,' ')}</option>)}
                  </select>
                </div>
                <div className="form-group"><label>Konu *</label>
                  <select value={form.sikayet_konusu} onChange={e=>setForm({...form,sikayet_konusu:e.target.value})} required>
                    <option value="">Seçin...</option>
                    {['GURULTU','CEVRE_KIRLILIGI','RUHSATSIZ','KAPASITE_ASIMI','CALISMA_SAATI','HIJYEN','GUVENLIK','YANGIN','DIGER'].map(k=><option key={k} value={k}>{k.replace(/_/g,' ')}</option>)}
                  </select>
                </div>
                <div className="form-group"><label>Tarih</label><input type="date" value={form.sikayet_tarihi} onChange={e=>setForm({...form,sikayet_tarihi:e.target.value})} /></div>
                <div className="form-group" style={{display:'flex',alignItems:'center',gap:'8px',paddingTop:'22px'}}>
                  <input type="checkbox" id="anm" checked={form.anonim} onChange={e=>setForm({...form,anonim:e.target.checked})} />
                  <label htmlFor="anm" style={{marginBottom:0}}>Anonim</label>
                </div>
                {!form.anonim&&<div className="form-group" style={{gridColumn:'1/-1'}}><label>Başvuru Sahibi</label><input value={form.basvuru_sahibi} onChange={e=>setForm({...form,basvuru_sahibi:e.target.value})} /></div>}
                <div className="form-group" style={{gridColumn:'1/-1'}}><label>Açıklama</label><textarea value={form.sikayet_aciklama} onChange={e=>setForm({...form,sikayet_aciklama:e.target.value})} rows={3}/></div>
              </div>
              <div className="modal-footer"><button type="button" className="btn btn-secondary" onClick={()=>setModalAcik(false)}>İptal</button><button type="submit" className="btn btn-primary">Kaydet</button></div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

function YaptirimTab({ ruhsatId }) {
  const { kullanici } = useContext(AuthContext);
  const [veri, setVeri] = useState([]);
  const [modalAcik, setModalAcik] = useState(false);
  const [form, setForm] = useState({ yaptirim_turu:'IHTAR', karar_tarihi:new Date().toISOString().split('T')[0], karar_no:'', ceza_tutari:'', muhur_no:'', kapatma_baslangic:'', kapatma_bitis:'', yaptirim_aciklama:'' });
  const mudurAdmin = ['admin','mudur'].includes(kullanici?.rol);
  const fmt = d => d ? new Date(d).toLocaleDateString('tr-TR') : '—';
  const para = v => v ? Number(v).toLocaleString('tr-TR',{minimumFractionDigits:2})+' ₺' : '—';

  useEffect(() => { api.get(`/yaptirim/ruhsat/${ruhsatId}`).then(r=>setVeri(r.data||[])); }, [ruhsatId]);
  const yukle = () => api.get(`/yaptirim/ruhsat/${ruhsatId}`).then(r=>setVeri(r.data||[]));

  const kaydet = async (e) => {
    e.preventDefault();
    try { await api.post('/yaptirim', {...form, ruhsat_id:ruhsatId}); yukle(); setModalAcik(false); }
    catch(err){ alert(err.response?.data?.hata||'Hata'); }
  };

  return (
    <div>
      <div style={{display:'flex',justifyContent:'space-between',marginBottom:'12px'}}>
        <span style={{color:'#c62828',fontWeight:'700',fontSize:'13px'}}>{veri.filter(v=>v.aktif).length} aktif yaptırım</span>
        {mudurAdmin&&<button className="btn btn-primary btn-sm" onClick={()=>setModalAcik(true)}>➕ Yaptırım Ekle</button>}
      </div>
      {veri.length===0?<p style={{color:'#999',fontSize:'13px'}}>Yaptırım kaydı yok.</p>:(
        <table>
          <thead><tr><th>Tür</th><th>Karar Tarihi</th><th>Ceza Tutarı</th><th>Mühür No</th><th>Kapatma</th><th>Durum</th></tr></thead>
          <tbody>
            {veri.map(y=>(
              <tr key={y.id}>
                <td style={{fontSize:'11px',fontWeight:'700',color:'#c62828'}}>{y.yaptirim_turu?.replace(/_/g,' ')}</td>
                <td style={{fontSize:'12px'}}>{fmt(y.karar_tarihi)}</td>
                <td style={{fontWeight:'700'}}>{para(y.ceza_tutari)}</td>
                <td style={{fontFamily:'monospace',fontSize:'12px'}}>{y.muhur_no||'—'}</td>
                <td style={{fontSize:'12px'}}>{y.kapatma_baslangic?`${fmt(y.kapatma_baslangic)} — ${fmt(y.kapatma_bitis)}`:'—'}</td>
                <td>{y.aktif?<span style={{color:'#c62828',fontWeight:'700',fontSize:'11px'}}>⚠ AKTİF</span>:<span style={{color:'#888',fontSize:'11px'}}>Pasif</span>}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      {modalAcik&&(
        <div className="modal-overlay" onClick={e=>e.target===e.currentTarget&&setModalAcik(false)}>
          <div className="modal" style={{maxWidth:'500px'}}>
            <div className="modal-header"><span className="modal-title">Yaptırım Ekle</span><button className="modal-close" onClick={()=>setModalAcik(false)}>×</button></div>
            <form onSubmit={kaydet}>
              <div className="form-grid">
                <div className="form-group"><label>Yaptırım Türü *</label>
                  <select value={form.yaptirim_turu} onChange={e=>setForm({...form,yaptirim_turu:e.target.value})} required>
                    {['IDARI_PARA_CEZASI','GECICI_KAPATMA','KALICI_KAPATMA','IHTAR','MUHUR_FEKKI'].map(k=><option key={k} value={k}>{k.replace(/_/g,' ')}</option>)}
                  </select>
                </div>
                <div className="form-group"><label>Karar Tarihi</label><input type="date" value={form.karar_tarihi} onChange={e=>setForm({...form,karar_tarihi:e.target.value})} /></div>
                <div className="form-group"><label>Karar No</label><input value={form.karar_no} onChange={e=>setForm({...form,karar_no:e.target.value})} /></div>
                <div className="form-group"><label>Ceza Tutarı (₺)</label><input type="number" step="0.01" min="0" value={form.ceza_tutari} onChange={e=>setForm({...form,ceza_tutari:e.target.value})} /></div>
                <div className="form-group"><label>Mühür No</label><input value={form.muhur_no} onChange={e=>setForm({...form,muhur_no:e.target.value})} /></div>
                <div className="form-group"><label>Kapatma Başlangıç</label><input type="date" value={form.kapatma_baslangic} onChange={e=>setForm({...form,kapatma_baslangic:e.target.value})} /></div>
                <div className="form-group"><label>Kapatma Bitiş</label><input type="date" value={form.kapatma_bitis} onChange={e=>setForm({...form,kapatma_bitis:e.target.value})} /></div>
                <div className="form-group" style={{gridColumn:'1/-1'}}><label>Açıklama</label><textarea value={form.yaptirim_aciklama} onChange={e=>setForm({...form,yaptirim_aciklama:e.target.value})} rows={2}/></div>
              </div>
              <div className="modal-footer"><button type="button" className="btn btn-secondary" onClick={()=>setModalAcik(false)}>İptal</button><button type="submit" className="btn btn-primary">Kaydet</button></div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

function DenetimTab({ ruhsatId }) {
  const [veri, setVeri] = useState([]);
  const fmt = d => d ? new Date(d).toLocaleDateString('tr-TR') : '—';
  const DURUM_RENK = { PLANLI:'#1565c0', GERCEKLESTI:'#1b5e20', IPTAL:'#c62828', ERTELENDI:'#e65100' };

  useEffect(() => { api.get(`/denetim/ruhsat/${ruhsatId}`).then(r=>setVeri(r.data||[])); }, [ruhsatId]);

  return (
    <div>
      {veri.length===0?<p style={{color:'#999',fontSize:'13px'}}>Denetim kaydı yok.</p>:(
        <table>
          <thead><tr><th>Denetim No</th><th>Plan Tarihi</th><th>Gerçekleşen</th><th>Tür</th><th>Denetleyen</th><th>Durum</th><th>Bulgu</th></tr></thead>
          <tbody>
            {veri.map(d=>(
              <tr key={d.id}>
                <td style={{fontFamily:'monospace',fontSize:'12px',color:'#1a237e'}}>{d.denetim_no}</td>
                <td style={{fontSize:'12px'}}>{fmt(d.planlanan_tarih)}</td>
                <td style={{fontSize:'12px',color:d.gerceklesen_tarih?'#1b5e20':'#bbb'}}>{fmt(d.gerceklesen_tarih)}</td>
                <td style={{fontSize:'11px'}}>{d.denetim_turu?.replace(/_/g,' ')}</td>
                <td style={{fontSize:'12px'}}>{d.denetleyen1_adi||'—'}</td>
                <td><span style={{fontSize:'11px',fontWeight:'700',color:DURUM_RENK[d.durum]||'#555'}}>{d.durum}</span></td>
                <td style={{fontSize:'11px',maxWidth:'150px',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{d.bulgular||'—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

function DevirTab({ ruhsatId }) {
  const { kullanici } = useContext(AuthContext);
  const [veri, setVeri] = useState([]);
  const [modalAcik, setModalAcik] = useState(false);
  const [form, setForm] = useState({ devir_tarihi:'', noter_adi:'', noter_tarihi:'', noter_no:'', aciklama:'' });
  const [sicilArama, setSicilArama] = useState('');
  const [sicilSonuc, setSicilSonuc] = useState([]);
  const mudurAdmin = ['admin','mudur'].includes(kullanici?.rol);
  const fmt = d => d ? new Date(d).toLocaleDateString('tr-TR') : '—';

  useEffect(() => { api.get(`/ruhsat/${ruhsatId}/devir`).then(r=>setVeri(r.data||[])); }, [ruhsatId]);
  const yukle = () => api.get(`/ruhsat/${ruhsatId}/devir`).then(r=>setVeri(r.data||[]));

  const sicilAra = async () => {
    if (!sicilArama) return;
    const r = await api.get(`/sicil?q=${sicilArama}&limit=10`);
    setSicilSonuc(r.data.veriler||[]);
  };

  const kaydet = async (e) => {
    e.preventDefault();
    try { await api.post(`/ruhsat/${ruhsatId}/devir`, form); yukle(); setModalAcik(false); setSicilArama(''); setSicilSonuc([]); }
    catch(err){ alert(err.response?.data?.hata||'Hata'); }
  };

  return (
    <div>
      <div style={{display:'flex',justifyContent:'space-between',marginBottom:'12px'}}>
        <span style={{fontSize:'13px',color:'#666'}}>{veri.length} devir kaydı</span>
        {mudurAdmin&&<button className="btn btn-primary btn-sm" onClick={()=>setModalAcik(true)}>➕ Devir Kaydı</button>}
      </div>
      {veri.length===0?<p style={{color:'#999',fontSize:'13px'}}>Devir kaydı yok.</p>:(
        <table>
          <thead><tr><th>Devir Tarihi</th><th>Eski Sahip</th><th>Yeni Sahip</th><th>Noter</th><th>Karar No</th></tr></thead>
          <tbody>
            {veri.map(d=>(
              <tr key={d.id}>
                <td style={{fontSize:'12px'}}>{fmt(d.devir_tarihi)}</td>
                <td style={{fontSize:'12px'}}>{d.eski_sahip_adi||'—'}</td>
                <td style={{fontSize:'12px',fontWeight:'600'}}>{d.yeni_sahip_adi||'—'}</td>
                <td style={{fontSize:'12px'}}>{d.noter_adi||'—'}</td>
                <td style={{fontSize:'12px',fontFamily:'monospace'}}>{d.noter_no||'—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      {modalAcik&&(
        <div className="modal-overlay" onClick={e=>e.target===e.currentTarget&&setModalAcik(false)}>
          <div className="modal" style={{maxWidth:'500px'}}>
            <div className="modal-header"><span className="modal-title">Devir Kaydı Ekle</span><button className="modal-close" onClick={()=>setModalAcik(false)}>×</button></div>
            <form onSubmit={kaydet}>
              <div className="form-grid">
                <div className="form-group" style={{gridColumn:'1/-1'}}>
                  <label>Yeni Sahip (Sicil) *</label>
                  <div style={{display:'flex',gap:'8px'}}>
                    <input value={sicilArama} onChange={e=>setSicilArama(e.target.value)} placeholder="Ad, TC veya sicil no..." className="search-input" onKeyDown={e=>e.key==='Enter'&&(e.preventDefault(),sicilAra())} />
                    <button type="button" className="btn btn-outline" onClick={sicilAra}>Ara</button>
                  </div>
                  {sicilSonuc.length>0&&(
                    <div style={{border:'1px solid #ddd',borderRadius:'4px',marginTop:'4px',maxHeight:'130px',overflowY:'auto',background:'#fff'}}>
                      {sicilSonuc.map(s=>(
                        <div key={s.id} onClick={()=>{setForm(f=>({...f,yeni_sahip_id:s.id}));setSicilArama(`${s.ad_unvan}`);setSicilSonuc([]);}}
                          style={{padding:'8px 12px',cursor:'pointer',borderBottom:'1px solid #f0f0f0',fontSize:'13px'}}
                          onMouseOver={e=>e.currentTarget.style.background='#f5f5ff'} onMouseOut={e=>e.currentTarget.style.background='#fff'}>
                          {s.ad_unvan} <span style={{color:'#888',fontSize:'11px'}}>({s.tcno||s.vn})</span>
                        </div>
                      ))}
                    </div>
                  )}
                  {form.yeni_sahip_id&&<div style={{fontSize:'12px',color:'#1b5e20',marginTop:'4px'}}>✅ Seçildi</div>}
                </div>
                <div className="form-group"><label>Devir Tarihi *</label><input type="date" value={form.devir_tarihi} onChange={e=>setForm({...form,devir_tarihi:e.target.value})} required /></div>
                <div className="form-group"><label>Noter Adı</label><input value={form.noter_adi} onChange={e=>setForm({...form,noter_adi:e.target.value})} /></div>
                <div className="form-group"><label>Noter Tarihi</label><input type="date" value={form.noter_tarihi} onChange={e=>setForm({...form,noter_tarihi:e.target.value})} /></div>
                <div className="form-group"><label>Noter No</label><input value={form.noter_no} onChange={e=>setForm({...form,noter_no:e.target.value})} /></div>
                <div className="form-group" style={{gridColumn:'1/-1'}}><label>Açıklama</label><textarea value={form.aciklama} onChange={e=>setForm({...form,aciklama:e.target.value})} rows={2}/></div>
              </div>
              <div className="modal-footer"><button type="button" className="btn btn-secondary" onClick={()=>setModalAcik(false)}>İptal</button><button type="submit" className="btn btn-primary">Kaydet</button></div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

function IzinBelgeTab({ ruhsatId }) {
  const { kullanici } = useContext(AuthContext);
  const [veri, setVeri] = useState([]);
  const [modalAcik, setModalAcik] = useState(false);
  const [form, setForm] = useState({ belge_turu:'ITFAIYE_RAPORU', belge_no:'', veren_kurum:'', verilis_tarihi:'', gecerlilik_tarihi:'', aciklama:'' });
  const yazabilir = ['admin','mudur','personel'].includes(kullanici?.rol);
  const fmt = d => d ? new Date(d).toLocaleDateString('tr-TR') : '—';
  const BELGE_TURLERI = ['CED','EMISYON','DESARJ','ITFAIYE_RAPORU','ISYERI_ACMA_RUHSATI','DEPOLAMA_IZNI','GURULTU_RAPORU','DIGER'];

  useEffect(() => { api.get(`/ruhsat/${ruhsatId}/izin-belgeler`).then(r=>setVeri(r.data||[])); }, [ruhsatId]);
  const yukle = () => api.get(`/ruhsat/${ruhsatId}/izin-belgeler`).then(r=>setVeri(r.data||[]));

  const kaydet = async (e) => {
    e.preventDefault();
    try { await api.post(`/ruhsat/${ruhsatId}/izin-belgeler`, form); yukle(); setModalAcik(false); }
    catch(err){ alert(err.response?.data?.hata||'Hata'); }
  };
  const sil = async (id) => {
    if (!window.confirm('Silinecek. Emin misiniz?')) return;
    try { await api.delete(`/ruhsat/${ruhsatId}/izin-belgeler/${id}`); yukle(); } catch(err){ alert(err.response?.data?.hata||'Hata'); }
  };

  return (
    <div>
      <div style={{display:'flex',justifyContent:'space-between',marginBottom:'12px'}}>
        <span style={{fontSize:'12px',color:'#666'}}>ÇED, emisyon, deşarj, itfaiye raporları ve diğer izin belgeleri</span>
        {yazabilir&&<button className="btn btn-primary btn-sm" onClick={()=>setModalAcik(true)}>➕ İzin Belgesi Ekle</button>}
      </div>
      {veri.length===0?<p style={{color:'#999',fontSize:'13px'}}>İzin belgesi kaydı yok.</p>:(
        <table>
          <thead><tr><th>Belge Türü</th><th>Belge No</th><th>Veren Kurum</th><th>Veriliş</th><th>Geçerlilik</th><th>İşlem</th></tr></thead>
          <tbody>
            {veri.map(b=>(
              <tr key={b.id}>
                <td style={{fontSize:'11px',fontWeight:'600'}}>{b.belge_turu?.replace(/_/g,' ')}</td>
                <td style={{fontFamily:'monospace',fontSize:'12px'}}>{b.belge_no||'—'}</td>
                <td style={{fontSize:'12px'}}>{b.veren_kurum||'—'}</td>
                <td style={{fontSize:'12px'}}>{fmt(b.verilis_tarihi)}</td>
                <td style={{fontSize:'12px',color:b.gecerlilik_tarihi&&new Date(b.gecerlilik_tarihi)<new Date()?'#c62828':'#1b5e20'}}>{fmt(b.gecerlilik_tarihi)}</td>
                <td>{yazabilir&&<button className="btn btn-outline btn-xs" style={{color:'red'}} onClick={()=>sil(b.id)}>Sil</button>}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      {modalAcik&&(
        <div className="modal-overlay" onClick={e=>e.target===e.currentTarget&&setModalAcik(false)}>
          <div className="modal" style={{maxWidth:'460px'}}>
            <div className="modal-header"><span className="modal-title">İzin Belgesi Ekle</span><button className="modal-close" onClick={()=>setModalAcik(false)}>×</button></div>
            <form onSubmit={kaydet}>
              <div className="form-grid">
                <div className="form-group"><label>Belge Türü *</label>
                  <select value={form.belge_turu} onChange={e=>setForm({...form,belge_turu:e.target.value})} required>
                    {BELGE_TURLERI.map(k=><option key={k} value={k}>{k.replace(/_/g,' ')}</option>)}
                  </select>
                </div>
                <div className="form-group"><label>Belge No</label><input value={form.belge_no} onChange={e=>setForm({...form,belge_no:e.target.value})} /></div>
                <div className="form-group"><label>Veren Kurum</label><input value={form.veren_kurum} onChange={e=>setForm({...form,veren_kurum:e.target.value})} /></div>
                <div className="form-group"><label>Veriliş Tarihi</label><input type="date" value={form.verilis_tarihi} onChange={e=>setForm({...form,verilis_tarihi:e.target.value})} /></div>
                <div className="form-group"><label>Geçerlilik Tarihi</label><input type="date" value={form.gecerlilik_tarihi} onChange={e=>setForm({...form,gecerlilik_tarihi:e.target.value})} /></div>
                <div className="form-group" style={{gridColumn:'1/-1'}}><label>Açıklama</label><textarea value={form.aciklama} onChange={e=>setForm({...form,aciklama:e.target.value})} rows={2}/></div>
              </div>
              <div className="modal-footer"><button type="button" className="btn btn-secondary" onClick={()=>setModalAcik(false)}>İptal</button><button type="submit" className="btn btn-primary">Kaydet</button></div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

const ONEM_RENK = { NORMAL:'#1565c0', ONEMLI:'#e65100', KRITIK:'#b71c1c' };

function NotlarTab({ ruhsatId }) {
  const { kullanici } = useContext(AuthContext);
  const [notlar, setNotlar] = useState([]);
  const [form, setForm] = useState({ icerik:'', onem:'NORMAL' });
  const [yukleniyor, setYukleniyor] = useState(true);
  const [ekleme, setEkleme] = useState(false);

  useEffect(() => { yukle(); }, []); // eslint-disable-line

  const yukle = async () => {
    setYukleniyor(true);
    try {
      const r = await api.get(`/not/ruhsat/${ruhsatId}`);
      setNotlar(r.data || []);
    } catch { setNotlar([]); } finally { setYukleniyor(false); }
  };

  const kaydet = async (e) => {
    e.preventDefault();
    try {
      await api.post('/not', { ruhsat_id: ruhsatId, ...form });
      setForm({ icerik:'', onem:'NORMAL' });
      setEkleme(false);
      yukle();
    } catch (err) { alert(err.response?.data?.hata || 'Hata'); }
  };

  const sil = async (id) => {
    if (!window.confirm('Not silinsin mi?')) return;
    try { await api.delete(`/not/${id}`); yukle(); } catch (err) { alert(err.response?.data?.hata || 'Hata'); }
  };

  const fmt = d => d ? new Date(d).toLocaleString('tr-TR') : '—';

  if (yukleniyor) return <div style={{color:'#888',padding:'16px'}}>Yükleniyor...</div>;

  return (
    <div>
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'12px'}}>
        <div style={{fontSize:'13px',color:'#666'}}>{notlar.length} not</div>
        <button className="btn btn-primary btn-sm" onClick={()=>setEkleme(!ekleme)}>
          {ekleme ? '✕ İptal' : '➕ Not Ekle'}
        </button>
      </div>

      {ekleme && (
        <form onSubmit={kaydet} style={{background:'#f8f9ff',padding:'12px',borderRadius:'8px',marginBottom:'16px',border:'1px solid #e8eaf6'}}>
          <div className="form-group" style={{marginBottom:'8px'}}>
            <label>Not İçeriği *</label>
            <textarea value={form.icerik} onChange={e=>setForm({...form,icerik:e.target.value})} rows={3} required placeholder="Dahili not..." />
          </div>
          <div style={{display:'flex',gap:'8px',alignItems:'center',justifyContent:'space-between'}}>
            <select value={form.onem} onChange={e=>setForm({...form,onem:e.target.value})} style={{padding:'6px 10px',border:'1px solid #ddd',borderRadius:'4px',fontSize:'13px'}}>
              <option value="NORMAL">Normal</option>
              <option value="ONEMLI">Önemli</option>
              <option value="KRITIK">Kritik</option>
            </select>
            <button type="submit" className="btn btn-primary btn-sm">Kaydet</button>
          </div>
        </form>
      )}

      {notlar.length === 0 ? (
        <div style={{color:'#aaa',textAlign:'center',padding:'24px',fontSize:'13px'}}>
          Henüz not eklenmemiş. Yukarıdan not ekleyebilirsiniz.
        </div>
      ) : (
        <div style={{display:'flex',flexDirection:'column',gap:'10px'}}>
          {notlar.map(n=>(
            <div key={n.id} style={{padding:'12px',background:'#fff',border:`1px solid ${ONEM_RENK[n.onem]||'#e8eaf6'}`,borderLeft:`4px solid ${ONEM_RENK[n.onem]||'#1565c0'}`,borderRadius:'6px'}}>
              <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:'6px'}}>
                <div style={{display:'flex',gap:'8px',alignItems:'center'}}>
                  <span style={{fontWeight:'700',fontSize:'12px',color:ONEM_RENK[n.onem]||'#1565c0'}}>{n.onem}</span>
                  <span style={{fontSize:'11px',color:'#888'}}>{n.yazar_adi || kullanici?.ad_soyad}</span>
                  <span style={{fontSize:'11px',color:'#aaa'}}>{fmt(n.olusturma_tarihi)}</span>
                </div>
                {(n.yazar === kullanici?.id || ['admin','mudur'].includes(kullanici?.rol)) && (
                  <button onClick={()=>sil(n.id)} style={{background:'none',border:'none',cursor:'pointer',color:'#c62828',fontSize:'14px',padding:'0 4px'}}>🗑</button>
                )}
              </div>
              <div style={{fontSize:'13px',color:'#333',whiteSpace:'pre-wrap'}}>{n.icerik}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

function KosulTab({ ruhsatId }) {
  const { kullanici } = useContext(AuthContext);
  const [veri, setVeri] = useState([]);
  const [modalAcik, setModalAcik] = useState(false);
  const [form, setForm] = useState({ kosul_tipi:'GENEL', kosul_aciklamasi:'', son_tarih:'', yerine_getirildi:false });
  const mudurAdmin = ['admin','mudur'].includes(kullanici?.rol);
  const fmt = d => d ? new Date(d).toLocaleDateString('tr-TR') : '—';

  useEffect(() => { api.get(`/ruhsat/${ruhsatId}/kosullar`).then(r=>setVeri(r.data||[])); }, [ruhsatId]);
  const yukle = () => api.get(`/ruhsat/${ruhsatId}/kosullar`).then(r=>setVeri(r.data||[]));

  const kaydet = async (e) => {
    e.preventDefault();
    try { await api.post(`/ruhsat/${ruhsatId}/kosullar`, form); yukle(); setModalAcik(false); }
    catch(err){ alert(err.response?.data?.hata||'Hata'); }
  };
  const toggle = async (k) => {
    try { await api.patch(`/ruhsat/${ruhsatId}/kosullar/${k.id}`, { yerine_getirildi:!k.yerine_getirildi }); yukle(); }
    catch(err){ alert(err.response?.data?.hata||'Hata'); }
  };
  const sil = async (id) => {
    if (!window.confirm('Silinecek. Emin misiniz?')) return;
    try { await api.delete(`/ruhsat/${ruhsatId}/kosullar/${id}`); yukle(); } catch(err){ alert(err.response?.data?.hata||'Hata'); }
  };

  return (
    <div>
      <div style={{display:'flex',justifyContent:'space-between',marginBottom:'12px'}}>
        <span style={{fontSize:'13px',color:'#666'}}>{veri.filter(k=>!k.yerine_getirildi).length} bekleyen koşul</span>
        {mudurAdmin&&<button className="btn btn-primary btn-sm" onClick={()=>setModalAcik(true)}>➕ Koşul Ekle</button>}
      </div>
      {veri.length===0?<p style={{color:'#999',fontSize:'13px'}}>Özel koşul kaydı yok.</p>:(
        <div>
          {veri.map(k=>(
            <div key={k.id} style={{display:'flex',alignItems:'flex-start',gap:'12px',padding:'10px',border:'1px solid #e0e0e0',borderRadius:'6px',marginBottom:'8px',background:k.yerine_getirildi?'#f1f8e9':'#fff8e1'}}>
              <div style={{flex:1}}>
                <div style={{fontSize:'11px',fontWeight:'700',color:'#3949ab',marginBottom:'4px'}}>{k.kosul_tipi?.replace(/_/g,' ')}</div>
                <div style={{fontSize:'13px'}}>{k.kosul_aciklamasi}</div>
                {k.son_tarih&&<div style={{fontSize:'11px',color:'#e65100',marginTop:'4px'}}>Son tarih: {fmt(k.son_tarih)}</div>}
              </div>
              <div style={{display:'flex',flexDirection:'column',gap:'4px',alignItems:'flex-end'}}>
                {k.yerine_getirildi?<span style={{fontSize:'11px',color:'#1b5e20',fontWeight:'700'}}>✅ Tamamlandı</span>:<span style={{fontSize:'11px',color:'#e65100',fontWeight:'700'}}>⏳ Bekliyor</span>}
                {mudurAdmin&&<button className="btn btn-outline btn-xs" onClick={()=>toggle(k)}>{k.yerine_getirildi?'Geri Al':'Tamamlandı'}</button>}
                {mudurAdmin&&<button className="btn btn-outline btn-xs" style={{color:'red'}} onClick={()=>sil(k.id)}>Sil</button>}
              </div>
            </div>
          ))}
        </div>
      )}
      {modalAcik&&(
        <div className="modal-overlay" onClick={e=>e.target===e.currentTarget&&setModalAcik(false)}>
          <div className="modal" style={{maxWidth:'440px'}}>
            <div className="modal-header"><span className="modal-title">Koşul / Yükümlülük Ekle</span><button className="modal-close" onClick={()=>setModalAcik(false)}>×</button></div>
            <form onSubmit={kaydet}>
              <div className="form-group"><label>Koşul Tipi</label>
                <select value={form.kosul_tipi} onChange={e=>setForm({...form,kosul_tipi:e.target.value})}>
                  {['GENEL','CEVRE','ISG','TEKNIK','HUKUKI','DIGER'].map(k=><option key={k} value={k}>{k.replace(/_/g,' ')}</option>)}
                </select>
              </div>
              <div className="form-group"><label>Koşul Açıklaması *</label><textarea value={form.kosul_aciklamasi} onChange={e=>setForm({...form,kosul_aciklamasi:e.target.value})} rows={3} required /></div>
              <div className="form-group"><label>Son Tarih</label><input type="date" value={form.son_tarih} onChange={e=>setForm({...form,son_tarih:e.target.value})} /></div>
              <div className="modal-footer"><button type="button" className="btn btn-secondary" onClick={()=>setModalAcik(false)}>İptal</button><button type="submit" className="btn btn-primary">Kaydet</button></div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

function RuhsatYenilemeler({ ruhsatId }) {
  const { kullanici } = useContext(AuthContext);
  const [yenilemeler, setYenilemeler] = useState([]);
  const [modalAcik, setModalAcik] = useState(false);
  const [form, setForm] = useState({ yenileme_yili: new Date().getFullYear(), aciklama:'' });
  const yazabilir = ['admin','mudur','personel'].includes(kullanici?.rol);

  useEffect(() => { yukle(); }, [ruhsatId]);
  const yukle = () => api.get(`/ruhsat/${ruhsatId}/yenilemeler`).then(r => setYenilemeler(r.data));

  const kaydet = async (e) => {
    e.preventDefault();
    try {
      await api.post(`/ruhsat/${ruhsatId}/yenilemeler`, form);
      yukle(); setModalAcik(false); alert('Ruhsat yenileme kaydedildi!');
    } catch (err) { alert(err.response?.data?.hata || 'Hata'); }
  };

  return (
    <div>
      {yazabilir && <button className="btn btn-primary btn-sm" style={{marginBottom:'12px'}} onClick={() => setModalAcik(true)}>🔄 Yenileme Ekle</button>}
      {yenilemeler.length === 0 ? (
        <p style={{color:'#999', fontSize:'13px'}}>Henüz yenileme kaydı bulunmuyor.</p>
      ) : (
        <table>
          <thead><tr><th>Yıl</th><th>Yenileme Tarihi</th><th>Açıklama</th><th>İşlemi Yapan</th></tr></thead>
          <tbody>
            {yenilemeler.map(y => (
              <tr key={y.id}>
                <td><strong style={{color:'#1a237e'}}>{y.yenileme_yili}</strong></td>
                <td>{y.yenileme_tarihi ? new Date(y.yenileme_tarihi).toLocaleDateString('tr-TR') : '—'}</td>
                <td style={{fontSize:'12px', color:'#666'}}>{y.aciklama||'—'}</td>
                <td style={{fontSize:'12px'}}>{y.yapan||'—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      {modalAcik && (
        <div className="modal-overlay" onClick={e => e.target===e.currentTarget && setModalAcik(false)}>
          <div className="modal" style={{maxWidth:'400px'}}>
            <div className="modal-header">
              <span className="modal-title">Ruhsat Yenileme</span>
              <button className="modal-close" onClick={() => setModalAcik(false)}>×</button>
            </div>
            <form onSubmit={kaydet}>
              <div className="form-group" style={{marginBottom:'12px'}}>
                <label>Yenileme Yılı *</label>
                <input type="number" value={form.yenileme_yili} onChange={e => setForm({...form, yenileme_yili: e.target.value})} min="2000" max="2100" required />
              </div>
              <div className="form-group"><label>Açıklama</label><textarea value={form.aciklama} onChange={e => setForm({...form, aciklama: e.target.value})} rows={3} /></div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setModalAcik(false)}>İptal</button>
                <button type="submit" className="btn btn-success">🔄 Yenile</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default function RuhsatDetay() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { kullanici } = useContext(AuthContext);
  const [ruhsat, setRuhsat] = useState(null);
  const [yukleniyor, setYukleniyor] = useState(true);
  const [aktifTab, setAktifTab] = useState('genel');
  const [durumModal, setDurumModal] = useState(false);
  const [yeniDurum, setYeniDurum] = useState('');
  const [iptalAciklama, setIptalAciklama] = useState('');
  const [iptalNedenleri, setIptalNedenleri] = useState([]);
  const [iptalNedenId, setIptalNedenId] = useState('');

  useEffect(() => {
    api.get(`/ruhsat/${id}`).then(r => setRuhsat(r.data)).finally(() => setYukleniyor(false));
    api.get('/tanimlar/iptal-nedenleri').then(r => setIptalNedenleri(r.data));
  }, [id]);

  const durumDegistir = async () => {
    try {
      await api.patch(`/ruhsat/${id}/durum`, { durum: yeniDurum, iptal_neden_id: iptalNedenId, iptal_aciklama: iptalAciklama });
      setDurumModal(false);
      const r = await api.get(`/ruhsat/${id}`);
      setRuhsat(r.data);
      alert('Durum güncellendi!');
    } catch (err) { alert(err.response?.data?.hata || 'Hata'); }
  };

  const belgeGuncelle = async (belgeId, teslim_edildi, aciklama) => {
    await api.patch(`/ruhsat/${id}/belge/${belgeId}`, { teslim_edildi, teslim_tarihi: teslim_edildi ? new Date().toISOString().split('T')[0] : null, aciklama });
    const r = await api.get(`/ruhsat/${id}`);
    setRuhsat(r.data);
  };

  if (yukleniyor) return <div className="loading">Yükleniyor...</div>;
  if (!ruhsat) return <div className="alert alert-error">Kayıt bulunamadı</div>;

  const formatTarih = (t) => t ? new Date(t).toLocaleDateString('tr-TR') : '—';
  const formatSaat = (s) => s ? s.substring(0,5) : '—';
  const yazabilir = ['admin','mudur','personel'].includes(kullanici?.rol);

  const onKontrolSorular = [
    'İşyeri gerekli faaliyet koluna uygun mu?',
    'İşyeri amacına uygun temiz ve aydınlık mı?',
    'İşyeri yakınında patlayıcı/parlayıcı madde satan yer var mı?',
    'Okul, yurt, mabet vb. binalara 100 metre mesafede mi? (uzaksa Evet)',
    'İşyeri umuma açık içkili mi?',
    'İçkili ise, içkili alan krokisi içinde mi?',
    'İşyerinin çevrede ikamet edenlere olumsuzluğu söz konusu mu?',
    'Karayolu geçiş izin belgesi gerekiyor mu?',
    'Engellilerin giriş/çıkışları için kolaylaştırıcı tedbirler alınmış mı?',
    'Yangın/alarm sistemi uygun mu?',
    'Tabela izin belgesi var mı?',
    'Gürültü/titreşim kontrolü yapıldı mı?',
    'Taşkın/sel bölgesinde mi?',
    'Asansör periyodik kontrol var mı?',
    'Diğer kontrol',
  ];
  const sonKontrolSorular = [
    'İşyeri amacına uygun temiz ve aydınlık mı?',
    'Çalışan personel temizlik kurallarına uygun mu?',
    'İşyerinde 10 kişiden fazla çalışan var mı?',
    '10+ çalışan varsa dinlenme/kıyafet değiştirme kabini var mı?',
    'Isınma sistemi (soba, kalorifer, klima) uygun yapılmış mı?',
    'Engelliler için gerekli tedbirler alınmış mı?',
    'İşyeri zemini, tavanı, duvarları kolay temizlenebilir nitelikte mi?',
    'Yeterli tuvalet ve lavabo var mı?',
    'Tuvalet ve lavabo kolay temizlenebilir nitelikte mi?',
    'Çevrede ikamet edenlere olumsuzluğu söz konusu mu?',
    'İşyeri "Ustalık Belgesi" gerektiren yer mi?',
    'Ustalık belgesi gerektiriyorsa en az 1 kişide belge var mı?',
    'Yangın söndürme cihazları uygun mu?',
    'Acil çıkış işaretleri var mı?',
    'SGK kayıt/bildirge uyumu var mı?',
    'Vergi levhası asılı mı?',
    'Ruhsat/belge asılı mı?',
    'Hijyen eğitimi sertifikaları var mı?',
    'İş güvenliği uzmanı var mı?',
    'Diğer kontrol',
  ];
  const zabitaSorular = [
    'Başvuruya konu yer fiziki olarak mevcut mu?',
    'İşyeri tabelası mevcut mu?',
    'İşyerinde çalışan var mı?',
    'Kira/mülkiyet belgesi var mı?',
    'Kapasite uygun mu?',
    'Ruhsatlı görünüyor mu?',
    'Uyarı yapıldı mı?',
    'Mühürleme yapıldı mı?',
    'Çalışma saatleri uygun mu?',
    'Gürültü seviyesi uygun mu?',
    'Sokağa/çevreye zarar veriyor mu?',
    'Alkol/sigara satışı yasal çerçevede mi?',
    'Yangın güvenliği yeterli mi?',
    'Yayalara engel oluşturuyor mu?',
    'Kaçak/kayıt dışı faaliyet var mı?',
    'Genel değerlendirme uygun mu?',
  ];
  const beyanSorular = [
    'Özürlü/engelli çalışan istihdam ediliyor mu?',
    'Esnaf/sanatkar sicil tasdiknamesi var mı?',
    'Kat mülkiyeti/yönetim izni alındı mı?',
    'Özel yapı şekli izni gerekiyor mu?',
    'Karayolu trafik güvenliği uygunluk belgesi var mı?',
    'İtfaiye olumlu görüş/raporu var mı?',
    'Mesafe krokisi hazırlandı mı? (umuma açık işyerleri)',
    'İşyeri umuma açık yer niteliğinde mi?',
    'ÇED belgesi gerekiyor mu?',
    'Emisyon izni gerekiyor mu?',
    'Deşarj izni gerekiyor mu?',
    'Tehlikeli atık lisansı gerekiyor mu?',
    'İş Sağlığı ve Güvenliği uzmanı var mı?',
    'Sosyal tesis niteliği taşıyor mu?',
    'Engelli erişim tedbirleri alındı mı?',
  ];
  const tespitSorular = [
    'İşyeri fiziki olarak yerinde mevcut mu?',
    'Ruhsatsız/izinsiz faaliyet var mı?',
    'Belirlenen kapasitenin üzerinde kullanım var mı?',
    'Çevre kirliliğine yol açıyor mu?',
    'Gürültü şikayeti var mı?',
    'Yangın güvenliği yeterli mi?',
    'Hijyen koşulları uygun mu?',
    'İşçi sağlığı/güvenliği koşulları uygun mu?',
    'Vergi levhası görünür yerde asılı mı?',
    'Ruhsat/izin belgesi asılı mı?',
    'Uyarı yapıldı mı?',
    'Mühürleme yapıldı mı?',
  ];

  const TABS = [
    { k:'genel', v:'Genel Bilgiler' },
    { k:'belgeler', v:'Belgeler' },
    { k:'beyan', v:'Beyan Formu' },
    { k:'onkontrol', v:'Ön Kontrol' },
    { k:'sonkontrol', v:'Son Kontrol' },
    { k:'zabita', v:'Zabıta Kontrol' },
    { k:'tespit', v:'Tespit Tutanağı' },
    { k:'ekler', v:'Ruhsat Ekleri' },
    { k:'yenileme', v:'Yenileme' },
    { k:'harc', v:'💰 Harç' },
    { k:'sikayet', v:'⚠️ Şikayet' },
    { k:'yaptirim', v:'🚫 Yaptırım' },
    { k:'denetim', v:'🔍 Denetim' },
    { k:'devir', v:'🔄 Devir' },
    { k:'izinbelge', v:'📄 İzin Belgeleri' },
    { k:'kosul', v:'📌 Koşullar' },
    { k:'notlar', v:'💬 Notlar' },
  ];

  return (
    <div>
      <div style={{display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:'20px'}}>
        <div>
          <button className="btn btn-secondary btn-sm" onClick={() => navigate(-1)} style={{marginBottom:'8px'}}>← Geri</button>
          <h2 style={{color:'#1a237e', fontSize:'20px'}}>{ruhsat.unvan}</h2>
          <div style={{display:'flex', gap:'8px', alignItems:'center', marginTop:'4px'}}>
            <span style={{fontSize:'16px', fontWeight:'700', color:'#3949ab'}}>{ruhsat.rn}</span>
            <span className={`badge badge-${ruhsat.durum?.toLowerCase()}`}>{DURUM_ETIKET[ruhsat.durum]}</span>
            {ruhsat.sinif_adi && <span style={{fontSize:'12px', background:'#e8eaf6', padding:'2px 8px', borderRadius:'10px', color:'#3949ab'}}>{ruhsat.sinif_adi}</span>}
          </div>
        </div>
        <div style={{display:'flex', gap:'8px', flexWrap:'wrap'}}>
          {yazabilir && <button className="btn btn-warning btn-sm" onClick={() => { setYeniDurum(''); setDurumModal(true); }}>🔄 Durum Değiştir</button>}
          {yazabilir && <button className="btn btn-outline btn-sm" onClick={() => navigate(`/ruhsat/${id}/duzenle`)}>✏️ Düzenle</button>}
          <button className="btn btn-primary btn-sm" onClick={() => ruhsatBelgesiOlustur(ruhsat, { belediye_adi:'Ünye Belediye Başkanlığı', belediye_adresi:'Ünye/Ordu', belediye_tel:'0452 XXX XX XX', baskan:'Belediye Başkanı', baskan_adi:'Hüseyin TAVLI', baskan_unvan:'BELEDİYE BAŞKANI' })}>📋 Ruhsat Belgesi</button>
          <button className="btn btn-secondary btn-sm" onClick={() => window.print()}>🖨️ Yazdır</button>
        </div>
      </div>

      <div className="tabs" style={{flexWrap:'wrap'}}>
        {TABS.map(t => (
          <button key={t.k} className={`tab ${aktifTab===t.k ? 'active' : ''}`} onClick={() => setAktifTab(t.k)}>{t.v}</button>
        ))}
      </div>

      {aktifTab === 'genel' && (
        <div className="card">
          <div className="detail-section">
            <h4>İşyeri Bilgileri</h4>
            <div className="detail-grid">
              <div className="detail-item"><label>Ruhsat No</label><span>{ruhsat.rn}</span></div>
              {ruhsat.ebelgeno && <div className="detail-item"><label>E-Belge No</label><span>{ruhsat.ebelgeno}</span></div>}
              {ruhsat.ebelgetarih && <div className="detail-item"><label>E-Belge Tarihi</label><span>{formatTarih(ruhsat.ebelgetarih)}</span></div>}
              {String(ruhsat.sicil_tipi_id) === '2' ? <>
                <div className="detail-item"><label>Firma Adı</label><span>{ruhsat.firma_adi || ruhsat.unvan || '—'}</span></div>
                <div className="detail-item"><label>Firma Ünvanı</label><span>{ruhsat.firma_unvani || '—'}</span></div>
              </> : <div className="detail-item"><label>İşyeri Ünvanı</label><span>{ruhsat.unvan}</span></div>}
              <div className="detail-item"><label>Ruhsat Türü</label><span>{ruhsat.ruhsat_turu_adi}</span></div>
              <div className="detail-item"><label>Sicil Tipi</label><span>{ruhsat.sicil_tipi_adi}</span></div>
              <div className="detail-item"><label>Ana Faaliyet</label><span>{ruhsat.ana_faaliyet_adi}</span></div>
              <div className="detail-item"><label>Faaliyet Sınıfı</label><span>{ruhsat.sinif_adi||'—'}</span></div>
              <div className="detail-item"><label>NACE Kodu</label><span>{ruhsat.nace_kodu_no ? `${ruhsat.nace_kodu_no} — ${ruhsat.nace_kodu_adi}` : '—'}</span></div>
              <div className="detail-item"><label>Takip Süresi</label><span>{ruhsat.takip_suresi ? `${ruhsat.takip_suresi} gün` : '—'}</span></div>
              <div className="detail-item"><label>Durum</label><span className={`badge badge-${ruhsat.durum?.toLowerCase()}`}>{DURUM_ETIKET[ruhsat.durum]}</span></div>
              <div className="detail-item"><label>Başvuru Tarihi</label><span>{formatTarih(ruhsat.basvuru_tarihi)}</span></div>
              {ruhsat.onay_tarihi && <div className="detail-item"><label>Onay Tarihi</label><span>{formatTarih(ruhsat.onay_tarihi)}</span></div>}
              {ruhsat.iptal_tarihi && <div className="detail-item"><label>İptal Tarihi</label><span>{formatTarih(ruhsat.iptal_tarihi)}</span></div>}
              {ruhsat.iptal_neden_adi && <div className="detail-item"><label>İptal Nedeni</label><span>{ruhsat.iptal_neden_adi}</span></div>}
              {ruhsat.iptal_aciklama && <div className="detail-item" style={{gridColumn:'1/-1'}}><label style={{color:'#1a237e',fontWeight:700}}>İptal Açıklaması</label><span>{ruhsat.iptal_aciklama}</span></div>}
            </div>
          </div>
          <div className="detail-section">
            <h4>İşyeri Adresi</h4>
            <div className="detail-grid">
              <div className="detail-item"><label>Adres</label><span>{ruhsat.isyeri_adresi||'—'}</span></div>
              <div className="detail-item"><label>Mahalle</label><span>{ruhsat.mahalle||'—'}</span></div>
              <div className="detail-item"><label>Sokak</label><span>{ruhsat.sokak||'—'}</span></div>
              <div className="detail-item"><label>Dış Kapı No</label><span>{ruhsat.is_diskapi||'—'}</span></div>
              <div className="detail-item"><label>İç Kapı No</label><span>{ruhsat.is_ickapi||'—'}</span></div>
              <div className="detail-item"><label>Kat No</label><span>{ruhsat.is_katno||'—'}</span></div>
              <div className="detail-item"><label>İl / İlçe</label><span>{ruhsat.is_il} / {ruhsat.is_ilce}</span></div>
              <div className="detail-item"><label>Ada / Parsel</label><span>{ruhsat.ada||'—'} / {ruhsat.parsel||'—'}</span></div>
            </div>
          </div>
          <div className="detail-section">
            <h4>Alan Bilgileri</h4>
            <div className="detail-grid">
              <div className="detail-item"><label>Kapalı Alan</label><span>{ruhsat.kapali_alan ? `${ruhsat.kapali_alan} m²` : '—'}</span></div>
              <div className="detail-item"><label>Açık Alan</label><span>{ruhsat.acik_alan ? `${ruhsat.acik_alan} m²` : '—'}</span></div>
              <div className="detail-item"><label>Kapasite</label><span>{ruhsat.kapasite ? `${ruhsat.kapasite} ${ruhsat.kapasite_tip||''}` : '—'}</span></div>
              <div className="detail-item"><label>Oda Sayısı</label><span>{ruhsat.oda_sayisi||'—'}</span></div>
              <div className="detail-item"><label>SGK'lı Çalışan</label><span>{ruhsat.sgk_sayisi||'—'}</span></div>
              <div className="detail-item"><label>Mülk Durumu</label><span>{ruhsat.mulk||'—'}</span></div>
              <div className="detail-item"><label>Yer / Bölge</label><span>{ruhsat.yer||'—'}</span></div>
            </div>
          </div>
          {ruhsat.depo_adresi && (
            <div className="detail-section">
              <h4>Depo Adresi</h4>
              <div className="detail-grid">
                <div className="detail-item"><label>Depo Adresi</label><span>{ruhsat.depo_adresi}</span></div>
                <div className="detail-item"><label>Dış Kapı / Kat</label><span>{ruhsat.depo_diskapi} / {ruhsat.depo_katno}</span></div>
                <div className="detail-item"><label>İl / İlçe</label><span>{ruhsat.depo_il} / {ruhsat.depo_ilce}</span></div>
              </div>
            </div>
          )}
          <div className="detail-section">
            <h4>Sahip / Firma Bilgileri</h4>
            {!ruhsat.sicil_id && !ruhsat.tcno && !ruhsat.vn && (
              <div style={{marginBottom:'10px', padding:'8px 12px', background:'#fff8e1', border:'1px solid #ffe082', borderRadius:'6px', fontSize:'12px', color:'#795548'}}>
                ⚠️ Bu ruhsata sicil kaydı bağlı değil. Düzenle butonundan sicil seçerek veya TC/VN girerek tamamlayabilirsiniz.
              </div>
            )}
            <div className="detail-grid">
              {(ruhsat.sicil_unvani || ruhsat.unvan) && <div className="detail-item" style={{gridColumn:'1/-1'}}><label>Ünvan / Ad</label><span>{ruhsat.sicil_unvani || (ruhsat.adi ? `${ruhsat.adi} ${ruhsat.soyadi||''}`.trim() : ruhsat.unvan)}</span></div>}
              <div className="detail-item"><label>T.C. Kimlik No</label><span>{ruhsat.tcno||'—'}</span></div>
              <div className="detail-item"><label>Vergi No</label><span>{ruhsat.vn||'—'}</span></div>
              <div className="detail-item"><label>Vergi Dairesi</label><span>{ruhsat.vd||'—'}</span></div>
              <div className="detail-item"><label>Telefon</label><span>{ruhsat.telefon||'—'}</span></div>
              <div className="detail-item"><label>Cep Telefonu</label><span>{ruhsat.cep_telefonu||'—'}</span></div>
              <div className="detail-item"><label>E-posta</label><span>{ruhsat.email||'—'}</span></div>
              <div className="detail-item"><label>Milliyet</label><span>{ruhsat.milliyet_adi||'—'}</span></div>
              <div className="detail-item"><label>Eğitim Durumu</label><span>{ruhsat.egitim_durumu||'—'}</span></div>
              <div className="detail-item"><label>Kan Grubu</label><span>{ruhsat.kan_grubu||'—'}</span></div>
              {ruhsat.sirket_tipi_adi && <div className="detail-item"><label>Şirket Tipi</label><span>{ruhsat.sirket_tipi_adi}</span></div>}
              {ruhsat.adi && <div className="detail-item"><label>Adı Soyadı</label><span>{ruhsat.adi} {ruhsat.soyadi}</span></div>}
              {ruhsat.babadi && <div className="detail-item"><label>Baba / Ana Adı</label><span>{ruhsat.babadi} / {ruhsat.anadi}</span></div>}
              {ruhsat.dogum_yeri && <div className="detail-item"><label>Doğum Yeri / Tarihi</label><span>{ruhsat.dogum_yeri} / {formatTarih(ruhsat.dogum_tarihi)}</span></div>}
            </div>
          </div>
          {(ruhsat.mulk_sahibi_adi || ruhsat.mulk_sahibi_unvani) && (
            <div className="detail-section">
              <h4>Mülk Sahibi Bilgileri</h4>
              <div className="detail-grid">
                <div className="detail-item"><label>Mülk Sahibi</label><span>{ruhsat.mulk_sahibi_unvani || `${ruhsat.mulk_sahibi_adi} ${ruhsat.mulk_sahibi_soyadi}`}</span></div>
              </div>
            </div>
          )}
          <div className="detail-section">
            <h4>Çalışma Saatleri</h4>
            <div className="detail-grid">
              <div className="detail-item"><label>Yaz Açılış (16 Mar - 14 Eki)</label><span>{formatSaat(ruhsat.yaz_acilis_saati)}</span></div>
              <div className="detail-item"><label>Yaz Kapanış</label><span>{formatSaat(ruhsat.yaz_kapanis_saati)}</span></div>
              <div className="detail-item"><label>Kış Açılış (15 Eki - 15 Mar)</label><span>{formatSaat(ruhsat.kis_acilis_saati)}</span></div>
              <div className="detail-item"><label>Kış Kapanış</label><span>{formatSaat(ruhsat.kis_kapanis_saati)}</span></div>
            </div>
          </div>
          {ruhsat.tali_faaliyetler?.length > 0 && (
            <div className="detail-section">
              <h4>Tali Faaliyetler</h4>
              {ruhsat.tali_faaliyetler.map(tf => <span key={tf.id} style={{display:'inline-block', background:'#e8eaf6', padding:'3px 10px', borderRadius:'10px', margin:'2px', fontSize:'12px'}}>{tf.faaliyet_adi}</span>)}
            </div>
          )}
        </div>
      )}

      {aktifTab === 'belgeler' && (
        <div className="card">
          <div className="card-header"><span className="card-title">Başvuru Belgeleri</span></div>
          <table>
            <thead><tr><th>#</th><th>Belge Adı</th><th>Zorunlu</th><th>Teslim</th><th>Teslim Tarihi</th><th>Açıklama</th><th>İşlem</th></tr></thead>
            <tbody>
              {(ruhsat.belgeler||[]).map((b, i) => (
                <tr key={b.id}>
                  <td>{i+1}</td>
                  <td>{b.belge_adi}</td>
                  <td>{b.zorunlu ? '⚠️ Zorunlu' : 'İsteğe Bağlı'}</td>
                  <td><span style={{color: b.teslim_edildi?'green':'#999'}}>{b.teslim_edildi ? '✅ Teslim Edildi' : '⏳ Bekleniyor'}</span></td>
                  <td>{b.teslim_tarihi ? new Date(b.teslim_tarihi).toLocaleDateString('tr-TR') : '—'}</td>
                  <td style={{fontSize:'12px', color:'#666'}}>{b.aciklama||'—'}</td>
                  <td>
                    {yazabilir && (
                      <button className="btn btn-sm" style={{background: b.teslim_edildi?'#ffebee':'#e8f5e9', color: b.teslim_edildi?'#b71c1c':'#1b5e20', border:'none'}}
                        onClick={() => belgeGuncelle(b.id, !b.teslim_edildi, b.aciklama)}>
                        {b.teslim_edildi ? '↩ Geri Al' : '✔ Teslim Alındı'}
                      </button>
                    )}
                  </td>
                </tr>
              ))}
              {(!ruhsat.belgeler||ruhsat.belgeler.length===0) && <tr><td colSpan="7" style={{textAlign:'center', color:'#999', padding:'20px'}}>Belge listesi oluşturulmamış</td></tr>}
            </tbody>
          </table>
        </div>
      )}

      {aktifTab === 'beyan' && (
        <div className="card">
          <div className="card-header"><span className="card-title">Başvuru Beyan Formu</span></div>
          <KontrolTutanagi ruhsatId={id} tip="beyan" sorular={beyanSorular} />
        </div>
      )}

      {aktifTab === 'onkontrol' && (
        <div className="card">
          <div className="card-header"><span className="card-title">Ön Kontrol Tutanağı</span></div>
          <KontrolTutanagi ruhsatId={id} tip="on" sorular={onKontrolSorular} />
        </div>
      )}

      {aktifTab === 'sonkontrol' && (
        <div className="card">
          <div className="card-header"><span className="card-title">Son Kontrol Tutanağı</span></div>
          <KontrolTutanagi ruhsatId={id} tip="son" sorular={sonKontrolSorular} />
        </div>
      )}

      {aktifTab === 'zabita' && (
        <div className="card">
          <div className="card-header"><span className="card-title">Zabıta Kontrol Tutanağı</span></div>
          <KontrolTutanagi ruhsatId={id} tip="zabita" sorular={zabitaSorular} />
        </div>
      )}

      {aktifTab === 'tespit' && (
        <div className="card">
          <div className="card-header"><span className="card-title">Tespit Tutanağı</span></div>
          <KontrolTutanagi ruhsatId={id} tip="tespit" sorular={tespitSorular} />
        </div>
      )}

      {aktifTab === 'ekler' && (
        <div className="card">
          <div className="card-header"><span className="card-title">Ruhsat Ekleri (Müdür/İzin/Müzik)</span></div>
          <RuhsatEkler ruhsatId={id} />
        </div>
      )}

      {aktifTab === 'yenileme' && (
        <div className="card">
          <div className="card-header"><span className="card-title">Yenileme Geçmişi</span></div>
          <RuhsatYenilemeler ruhsatId={id} />
        </div>
      )}

      {aktifTab === 'harc' && (
        <div className="card">
          <div className="card-header"><span className="card-title">💰 Harç ve Ücret Takibi</span></div>
          <HarcTab ruhsatId={id} />
        </div>
      )}

      {aktifTab === 'sikayet' && (
        <div className="card">
          <div className="card-header"><span className="card-title">⚠️ Şikayet / İhbar Kayıtları</span></div>
          <SikayetTab ruhsatId={id} />
        </div>
      )}

      {aktifTab === 'yaptirim' && (
        <div className="card">
          <div className="card-header"><span className="card-title">🚫 Yaptırım Kayıtları</span></div>
          <YaptirimTab ruhsatId={id} />
        </div>
      )}

      {aktifTab === 'denetim' && (
        <div className="card">
          <div className="card-header"><span className="card-title">🔍 Denetim Geçmişi</span></div>
          <DenetimTab ruhsatId={id} />
        </div>
      )}

      {aktifTab === 'devir' && (
        <div className="card">
          <div className="card-header"><span className="card-title">🔄 Devir / Temlik Kayıtları</span></div>
          <DevirTab ruhsatId={id} />
        </div>
      )}

      {aktifTab === 'izinbelge' && (
        <div className="card">
          <div className="card-header"><span className="card-title">📄 Çevre ve İSG İzin Belgeleri</span></div>
          <IzinBelgeTab ruhsatId={id} />
        </div>
      )}

      {aktifTab === 'kosul' && (
        <div className="card">
          <div className="card-header"><span className="card-title">📌 Ruhsata Özel Koşul / Yükümlülükler</span></div>
          <KosulTab ruhsatId={id} />
        </div>
      )}

      {aktifTab === 'notlar' && (
        <div className="card">
          <div className="card-header"><span className="card-title">💬 Dahili Notlar</span></div>
          <NotlarTab ruhsatId={id} />
        </div>
      )}

      {durumModal && (
        <div className="modal-overlay" onClick={e => e.target===e.currentTarget && setDurumModal(false)}>
          <div className="modal" style={{maxWidth:'450px'}}>
            <div className="modal-header">
              <span className="modal-title">Durum Değiştir</span>
              <button className="modal-close" onClick={() => setDurumModal(false)}>×</button>
            </div>
            <div className="form-group">
              <label>Yeni Durum</label>
              <select value={yeniDurum} onChange={e => setYeniDurum(e.target.value)}>
                <option value="">Seçin...</option>
                <option value="BASVURU">Beklemede</option>
                <option value="ONAYLANDI">Tamamlandı</option>
                <option value="IPTAL">İptal Ruhsat</option>
                <option value="INTIKAL_RUHSAT">İntikal Ruhsat</option>
                <option value="SON_KONTROL">Son Kontrol Bekliyor</option>
              </select>
            </div>
            {yeniDurum === 'ONAYLANDI' && (
              <div className="form-group" style={{marginTop:'12px'}}>
                <label>Onay Tarihi</label>
                <input type="date" defaultValue={new Date().toISOString().split('T')[0]} />
              </div>
            )}
            {yeniDurum === 'IPTAL' && (
              <>
                <div className="form-group" style={{marginTop:'12px'}}>
                  <label>İptal Nedeni</label>
                  <select value={iptalNedenId} onChange={e => setIptalNedenId(e.target.value)}>
                    <option value="">Seçin...</option>
                    {iptalNedenleri.map(n => <option key={n.id} value={n.id}>{n.neden_adi}</option>)}
                  </select>
                </div>
                <div className="form-group" style={{marginTop:'12px'}}>
                  <label>İptal Açıklaması</label>
                  <textarea value={iptalAciklama} onChange={e => setIptalAciklama(e.target.value)} rows={3} />
                </div>
              </>
            )}
            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={() => setDurumModal(false)}>İptal</button>
              <button className="btn btn-primary" onClick={durumDegistir} disabled={!yeniDurum}>Güncelle</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
